import styled from 'styled-components';

import ActionLink from 'components/ActionLink/ActionLink';
import {
  badgeCardBg,
  black,
  border1,
  cardBorder,
  exactWhite,
  gray,
  green,
  lightRed,
  lightRedSolid,
} from 'utils/style/colors';

export const MoreSpan = styled('span')`
  z-index: 399 !important;
  align-items: center;
  color: #2196f3;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 36px;
`;
interface TitleProps {
  deleted?: boolean;
}
export const Title = styled('div')<TitleProps>`
  z-index: 299;
  ${(props) =>
    props.deleted
      ? `
    & > div {
        color: ${gray}
    }
  
  `
      : ''}
  max-width: calc(100% - 5rem);
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0.5rem;
  /* margin-inline-start: ${(props) =>
    props?.selected ? '-13rem' : '-4rem'}; */
  margin-inline-start: -4rem;
  /* background-color: ${(props) =>
    props?.selected
      ? 'rgba(255, 255, 255, 0.5)'
      : 'rgba(255, 255, 255, 0.2)'}; */
  background-color: ${badgeCardBg};
  border-radius: 1rem;
  border: ${cardBorder};
  color: ${black};
`;

export const Description = styled('div')`
  color: #666;
  font-size: 0.8rem;
`;

export const ItemContainer = styled.li`
  min-height: 5rem;
  display: flex;
  justify-content: stretch;
  border-radius: 1rem;
  border: ${cardBorder};
  border-radius: 1rem;
  margin: 0.5rem;
  position: relative;
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  mix-blend-mode: lighten;
  z-index: 100;
  border-radius: 1rem;
`;

export const BadgeContainer = styled.div`
  /* width: ${(props) => (props.selected ? '18rem' : '9rem')}; */
  width: 9rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 1rem;
  background-image: ${(props) =>
    props.theme.direction === 'rtl'
      ? `linear-gradient(to left, ${props.bgColor} 0%, ${exactWhite} 100%)`
      : `linear-gradient(to right, ${props.bgColor} 0%, ${exactWhite} 100%)`};
  padding-inline-start: 1.5rem;
  color: ${exactWhite};
`;

export const BadgeLinkIcon = styled.div`
  font-size: 0.75rem;
  width: 1.2rem;
  height: 1.2rem;
`;

export const BadgeContent = styled.div``;

export const ItemAvatar = styled('div')`
  position: relative;
  margin-inline-end: 1rem;
  display: flex;
  align-items: center;
  & img {
    width: 2rem;
    height: 2rem;
  }
`;

export const BadgeIcon = styled('span')`
  border-radius: 50%;
  background-color: ${green};
  color: ${exactWhite};
  font-size: 0.5rem;
  width: 1.2rem;
  height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  bottom: 0;
`;

export const PickerActions = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: 1em 0;
`;

export const PickedItem = styled('div')`
  padding: 0.5rem 1.2rem;
  background: ${gray};
  border-radius: 10px;
  flex: 1;
  display: flex;
  justify-content: space-between;
`;

export const DescriptionLink = styled(ActionLink)`
  color: ${green};
  margin-bottom: 1rem;
  &:hover {
    color: #777;
  }
`;

export const CollectionItem = styled('div')`
  display: flex;
  border: ${border1};
  min-height: 4rem;
  padding: 0.75rem 1.25rem;
  margin: 10px;
  border-radius: 20px;
  position: relative;
  z-index: 20000000;
`;
export const CollectionContent = styled('div')`
  display: flex;
  flex: 1;
  align-items: center;

  & > form {
    flex: 1;
  }
`;

export const Filled = styled('span')`
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: green;
  color: ${exactWhite};
  direction: rtl;
  display: flex;
  flex-direction: row-reverse;
  padding: 1px 5px;
`;

export const AddTag = styled.a`
  color: ${black};
  display: flex;
  justify-content: flex-start;
  align-content: center;
  gap: 0.5rem;
`;

export const MoreActions = styled('div')`
  position: absolute;
  z-index: 400;
  top: 50%;
  display: flex;
  padding-inline-end: 0.5rem;

  ${(props) =>
    props.theme.direction === 'rtl'
      ? `
          left: 0 !important;
          transform: translateY(-50%);
        `
      : `
          right: 0 !important;
          transform: translateY(-50%);
        `};
`;

export const FileSizeAlert = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${exactWhite};
  margin-bottom: 1rem;
  border: 1px solid ${lightRed};
  border-radius: 0.5rem;
  background: ${lightRedSolid};
  padding: 0.1rem;
  font-size: 0.8rem;
`;
